import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FormService } from '../../organizations/features/booking/components/form/service';
import { CommonModule, DatePipe } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { DateAdapter, provideNativeDateAdapter, NativeDateAdapter } from '@angular/material/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { setHours, setMinutes } from 'date-fns';

export class CustomDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}

@Component({
  selector: 'app-datepicker-modal',
  imports: [
    MatDatepickerModule,
    DatePipe,
    MatMenuModule,
    TranslocoModule,
    CommonModule
  ],
  providers: [provideNativeDateAdapter(), DatePipe, { provide: DateAdapter, useClass: CustomDateAdapter }],
  templateUrl: './datepicker-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './datepicker-modal.component.scss',
})
export class DatePickerModalComponent {

  minDate: Date = new Date();
  maxDate: Date | null = null;
  selectedDate: Date | null = null;
  selectedTime: Date = new Date();
  timeSelector: boolean = false;

  currentTab: string = 'date';

  type: string | null = null;
  @Output() dateSelectEvent = new EventEmitter();
  @Output() timeSelectEvent = new EventEmitter();

  subscription: any;
  locale: string = "";

  hours: string[] = [];
  minutes: string[] = ['00', '15', '30', '45'];
  minutesArrival: string[] = ['10', '30', '50'];


  constructor(
    private _adapter: DateAdapter<any>,
    private translocoService: TranslocoService,
    public dialogRef: MatDialogRef<DatePickerModalComponent>,
    public datepipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: {
      form: FormService,
      type: string,
      selectedDate: Date | null,
      minDate: Date | null,
      isHotel: boolean,
      hotelDate: Date | null,
      timeSelector: boolean,

    },
  ) {

    this.type = data.type;
    this.timeSelector = data.timeSelector;
    this.hours = Array.from({ length: 24 }, (_, i) => (i < 10 ? '0' + i : '' + i));
    this.subscription = this.translocoService.langChanges$.subscribe((lang) => {
      this.locale = lang;
      this._adapter.setLocale(this.locale);


    });


    //@PAC This logic sets min/maxdate for the picker for "flygets", should probably be moved outside the component
    if (this.type === 'arrival') {
      const hotels = this.data.form.getForm().get('hotels');
      const search = this.data.form.getForm().get('search');


      if (search.controls.isDepartureHotel.value && hotels.controls.departureDatetime.value) {
        this.minDate = new Date(hotels.controls.departureDatetime.value);
      }

      if (search.controls.isDepartureHotel && search.controls.departureFlightDate.value) {

        this.minDate = new Date(search.controls.departureFlightDate.value)

      }

      if (!search.controls.isDepartureHotel.value && search.controls.departureFlightDate.value) {

        this.minDate = new Date(search.controls.departureFlightDate.value);
      }


      if (data.isHotel && data.hotelDate) {
        this.maxDate = new Date(data.hotelDate);
      }

    }

    if (data.isHotel && data.hotelDate && this.type === 'departure') {
      this.minDate = new Date(data.hotelDate);
    }

    if (!data.selectedDate && this.timeSelector) {
      this.selectedTime = new Date();

      if (this.type == "arrival") {
        this.selectedTime.setHours(12, 10, 0, 0);
      } else {
        this.selectedTime.setHours(12, 0, 0, 0);
      }

    } else {
      this.selectedDate = data.selectedDate;
      this.selectedTime = data.selectedDate!;
    }

  }

  changeTab(tab: string) {
    this.currentTab = tab;
    this.timeSelectEvent.emit(this.selectedTime);
  }

  changeHour(event: any) {
    const newHour = parseInt(event, 10);
    this.selectedTime = setHours(this.selectedTime, newHour);
    this.timeSelectEvent.emit(this.selectedTime);

  }

  changeMinute(event: any) {
    const newMinute = parseInt(event, 10);
    this.selectedTime = setMinutes(this.selectedTime, newMinute);
    this.timeSelectEvent.emit(this.selectedTime);
  }

  selectDate(date: any) {
    this.dateSelectEvent.emit(date);
    if (!this.timeSelector) {
      this.dialogRef.close();
    }

  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
